<template>
  <PForm
    ref="pForm"
    :heading="`${uploadFormState.edit ? 'Magic Upload' : 'Magic Upload'}`"
    :primary-cta="submitBtn"
    :secondary-cta="resetBtn"
    @close="closeForm"
    @submit.prevent="onSubmit"
    @reset="resetForm"
  >
    <div v-if="!(isLoading || isProcessed)">
      <div class="border-none q-ma-none q-pa-none">
        <div class="row q-col-gutter-lg">
          <div class="col-12">
            <PFile
              v-model="formData.file"
              accept=".pdf, .jpeg, .jpg, .png"
              label="Upload a Purchase Order file"
              help="Only PDF, JPEG, JPG, PNG file types are allowed"
              :validations="{
                key: 'name',
                label: 'Purchase Order file',
                required: true,
              }"
            >
            </PFile>
            <PFile
              v-if="formData.file"
              v-model="formData.file"
              class="q-mt-xxs"
              variant="re-upload"
            />
          </div>
          <div class="col-6">
            <PField
              v-model="formData.is_tax_included"
              label="PO items rate is tax inclusive?"
            >
              <template #control>
                <POptionGroup
                  v-model="formData.is_tax_included"
                  :options="[
                    {
                      label: 'Yes',
                      value: true,
                    },
                    {
                      label: 'No',
                      value: false,
                    },
                  ]"
                />
              </template>
            </PField>
          </div>
        </div>
      </div>
      <q-separator spaced />
      <p class="text-warning-70">
        <strong>Note:</strong>
        <span>
          This feature is experimental. <br />
          Please double check the PO items with the PDF manually for
          correctness!
        </span>
      </p>
    </div>
    <div v-if="isLoading">
      <p class="text-weight-bold q-mb-none">
        Please do not close this drawer! This may take between 5 to 15 seconds
        based on the PDF file data.
      </p>
      <span class="text-neutral-70">
        File: {{ formData?.file?.name }} is being processed.
      </span>
      <div class="flex justify-center items-center">
        <video
          :style="{
            width: '40%',
          }"
          src="~assets/animations/file-processing.webm"
          type="video/webm"
          autoplay
          loop
        ></video>
      </div>
    </div>
    <div v-if="isProcessed">
      <p class="text-primary">Purchase Order Added</p>
      <span>
        Found {{ processedItemsCount }} items. Skipped
        {{ skippedItems.length }} items as they are not found in the system.
        <br />
        <ul>
          <li v-for="(item, index) in skippedItems" :key="index">
            <span>{{ item.name }}</span>
          </li>
        </ul>
        Please add them & proceed
      </span>
    </div>
  </PForm>
</template>

<script setup>
import uploadFormModel from "src/modules/purchase-order/models/uploadForm";

const props = defineProps({
  toggle: {
    type: Object,
    default: () => {
      return {
        method: false,
        options: {},
      };
    },
  },
});

const pForm = ref(null);

const { uploadFormState } = storeToRefs(usePurchaseOrderStore());
const { uploadPurchaseOrder, toggleUploadForm } = usePurchaseOrderStore();

const { formData, isLoading, closeForm, resetForm, submitForm } = useForm({
  formModel: uploadFormModel(),
  formRef: pForm,
  isForm: uploadFormState,
  post: uploadPurchaseOrder,
  toggleForm: toggleUploadForm,
});

const isProcessed = ref(false);
const processedItemsCount = ref(0);
const skippedItems = ref([]);

const onSubmit = async () => {
  if (unref(formData).file) {
    const response = await submitForm(false);

    const result = response?.data?.data;

    processedItemsCount.value = result?.line_items?.length;

    skippedItems.value = result?.skipped_items;

    isProcessed.value = true;

    toggleMethod(response?.data?.data);
  }
};

const toggleMethod = (args) => {
  if (props.toggle.method) {
    if (args) {
      props.toggle.method(args);
    } else {
      props.toggle.method(props.toggle.options);
    }
  }
};

const submitBtn = computed(() => {
  if (unref(isLoading) || unref(isProcessed)) {
    return {};
  }

  return undefined;
});

const resetBtn = computed(() => {
  if (unref(isLoading)) {
    return {};
  }

  if (unref(isProcessed)) {
    return {
      label: "Close",
      onClick: () => {
        isProcessed.value = false;

        closeForm();
      },
    };
  }

  return undefined;
});
</script>
